import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import DataTable from 'react-data-table-component';
import { FaArrowLeft, FaChevronCircleLeft, FaEdit, FaEye, FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import { AsyncPaginate } from 'react-select-async-paginate';
import MasterService from '../../../../services/master/MasterService';
import TransaksiService from '../../../../services/transaksi/TransaksiService';
import JenisDokumen from '../../../../utilities/JenisDokumen';
import Negara from '../../../../utilities/Negara';
import UploadService from '../../../../services/transaksi/UploadService';
import { formatDateTimeLocalDateOnly } from '../../../../utilities/Utils';

const ViewDokumen = ({ dataDokumen, saveDokumen, cancelDokumen }) => {

    const [showAddDokumen, setShowAddDokumen] = useState(false);
    const handleCloseAddDokumen = () => setShowAddDokumen(false);
    const handleShowAddDokumen = () => {
        setValueSeri(0)
        setShowAddDokumen(true)
    }

    const [showEditDokumen, setShowEditDokumen] = useState(false);
    const handleCloseEditDokumen = () => setShowEditDokumen(false);
    const handleShowEditDokumen = async (row) => {
        // console.log(row)
        // setDetilDokumen(row)
        const resDok = await masterService.getJenisDokById(row.kodeDokumen)
        setValueJenisDokOpt(resDok.data)
        setValueJenisDok(row.kodeDokumen)
        setValueSeriDok(row.noSeriDok)
        setValueNoDok(row.nomor)
        setValueTglDok(row.tanggal)
        const resNeg = await masterService.getNegaraById(row.negara)
        setValueNegaraOpt(resNeg.data)
        setValueKodeNegara(row.negara)
        setValueDokPath(row.dokPath)
        setValueSeri(row.trPpkDokPK.seri)
        setShowEditDokumen(true)
    }

    const [showViewDokumen, setShowViewDokumen] = useState(false);
    const handleCloseViewDokumen = () => setShowViewDokumen(false);
    const handleShowViewDokumen = (row) => {
        setDetilDokumen(row)
        setShowViewDokumen(true)
    }

    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const handleCloseConfirmDelete = () => setShowConfirmDelete(false)
    const handleShowConfirmDelete = (row) => {
        setDetilDokumen(row)
        setShowConfirmDelete(true)
    }
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false)
    const [showDeleteFailed, setShowDeleteFailed] = useState(false)


    const [detilDokumen, setDetilDokumen] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const [countDok, setCountDok] = useState(0)

    let masterService = useMemo(() => new MasterService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [listPpmDok, setListPpmDok] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const [valueSeri, setValueSeri] = useState(0)
    const [valueJenisDokOpt, setValueJenisDokOpt] = useState(null)
    const [valueJenisDok, setValueJenisDok] = useState(null)
    const [valueSeriDok, setValueSeriDok] = useState(null)
    const [valueNoDok, setValueNoDok] = useState(null)
    const [valueTglDok, setValueTglDok] = useState(null)
    const [valueNegaraOpt, setValueNegaraOpt] = useState(null)
    const [valueKodeNegara, setValueKodeNegara] = useState(null)
    const [valueDokPath, setValueDokPath] = useState(null)
    const [valueDokName, setValueDokName] = useState(null)
    const [valueFile, setValueFile] = useState(null)

    useEffect(() => {
        if (!dataDokumen) return;
        setLoading(true)
        setListPpmDok(dataDokumen.data)
        setTotalData(dataDokumen.totalData)
        setLoading(false)
    }, [dataDokumen])

    const handleChangePage = async (page) => {
        const response = await transaksiService.listPpmDok(localStorage.getItem('nomorAjuStorage'), null, page, size)
        setListPpmDok(response.data.data)
        setTotalData(response.data.totalData)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await transaksiService.listPpmDok(localStorage.getItem('nomorAjuStorage'), null, page - 1, size)
        setListPpmDok(_res.data.data)
        setSize(size)
    }

    async function loadOptionJenisDokumen(search, loadedOption, { page = 1 }) {
        const response = await masterService.listJenisDok(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionNegDokOpt(search, loadedOption, { page = 1 }) {
        const response = await masterService.listNegara(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }

    const onChangeJenisDokOpt = e => {
        setValueJenisDokOpt(e)
        setValueJenisDok(e.id)
    }

    const onChangeSeriDok = e => {
        setValueSeriDok(e.target.value)
    }

    const onChangeNoDok = e => {
        setValueNoDok(e.target.value)
    }

    const onChangeTglDok = e => {
        setValueTglDok(e.target.value)
    }

    const onChangeNegDokOpt = e => {
        setValueNegaraOpt(e)
        setValueKodeNegara(e.kodeNegara)
    }

    const handleUploadFile = e => {
        e.preventDefault()
        // console.log(e)
        const file = e.target.files[0];
        // console.log(file)
        if (file) {
            if (file.type !== "application/pdf") {
                alert("Only PDF files are allowed.");
                return;
            }

            const newFileName = file.name.replaceAll(" ", "-").replace(".pdf", '_' + formatDateTimeLocalDateOnly(new Date()) + ".pdf")
            const renamedFile = new File([file], newFileName, {
                type: file.type
            })
            setValueDokName(renamedFile.name)
            setValueFile(renamedFile)
            setValueDokPath(process.env.REACT_APP_API_URL_FILE + '/view/' + localStorage.getItem("nomorAjuStorage") + '/' + renamedFile.name)
            // console.log(renamedFile)

            // const reader = new FileReader();
            // reader.readAsDataURL(file);

            // // reader.onload = () => {
            // //     const base64String = reader.result.split(',')[1];
            // //     setValueDokPath(base64String)
            // // };

            // reader.onerror = (error) => {
            //     console.error("Error reading file:", error);
            // };
        }
    }

    const [base64String, setBase64String] = useState(null)
    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClickPreview = async (dokPath) => {
        setBase64String(dokPath)
        setShowOpenPreview(true)
    }
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}

        if (!valueJenisDokOpt) checkKelengkapan.jenisDok = 'Jenis Dokumen Wajib Diisi'
        if (!valueNoDok) checkKelengkapan.nomor = 'Nomor Dokumen Wajib Diisi'
        if (!valueTglDok) checkKelengkapan.tanggal = 'Tanggal Dokumen Wajib Diisi'
        if (!valueNegaraOpt) checkKelengkapan.negara = 'Negara Dokumen Wajib Diisi'
        if (!valueFile) checkKelengkapan.file = 'File Wajib Diunggah'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                // let dataheader = JSON.parse(localStorage.getItem('dataHeaderStorage'))
                let nomorAjuStorage = localStorage.getItem('nomorAjuStorage')
                const resNextSeri = await transaksiService.nextSeri('dok', nomorAjuStorage)
                setLoadingSave(true)
                let jsonDataDokumen = {
                    kodeDokumen: valueJenisDok,
                    negara: valueKodeNegara,
                    noSeriDok: valueSeriDok,
                    nomor: valueNoDok,
                    tanggal: valueTglDok,
                    trPpkDokPK: {
                        nomorAju: nomorAjuStorage,
                        seri: valueSeri !== 0 ? valueSeri : resNextSeri.data
                    },
                    dokPath: valueDokPath,
                    dokNameOri: valueDokName
                }
                // console.log(jsonDataDokumen)
                const response = await transaksiService.addPpmDok(JSON.stringify(jsonDataDokumen))
                if (response.data.kode === '200') {
                    const resUpload = await uploadService.uploadFile(nomorAjuStorage, valueFile)
                    console.log(resUpload)
                    if (response.status === 200) {
                        setShowSaveSucces(true)
                        setShowConfirmSave(false)
                        setListPpmDok([...listPpmDok, jsonDataDokumen])
                    }
                }
                setLoadingSave(false)
                setCountDok(countDok + 1)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
                // console.log(error)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setLoadingSave(false)
        setShowSaveSucces(false)
        setShowAddDokumen(false)
        setShowEditDokumen(false)
        cancelDokumen('dokumen')
        localStorage.setItem('dataDokumenStorage', listPpmDok)
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const handleClickDelete = async () => {
        try {
            let jsonData = {
                nomorAju: detilDokumen.trPpkDokPK.nomorAju,
                seri: detilDokumen.trPpkDokPK.seri
            }
            const resDelete = await transaksiService.deletePpmDokById(jsonData)
            if (resDelete.data.kode === '200') {
                setShowConfirmDelete(false)
                setShowDeleteSuccess(true)
            }
        } catch (error) {
            setShowConfirmDelete(false)
            setShowDeleteFailed(true)
        }
    }

    const handleClickDeleteSuccess = () => {
        setShowDeleteSuccess(false)
        setShowConfirmDelete(false)
        cancelDokumen('dokumen')
        localStorage.setItem('dataDokumenStorage', listPpmDok)
    }

    const handleClickDeleteFailed = () => {
        setShowDeleteFailed(false)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trPpkDokPK'].seri,
            grow: 0
        },
        {
            name: 'Kode Dokumen',
            cell: row => <JenisDokumen id={row['kodeDokumen']} />
        },
        {
            name: 'Nomor Dokumen',
            cell: row => row['nomor']
        },
        {
            name: 'Tanggal',
            cell: row => row['tanggal']
        },
        {
            name: 'Negara',
            cell: row => (<>{row['negara']} - &nbsp; <Negara id={row['negara']} /></>)
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-sm-3'>
                            <Button size='sm' variant='info' onClick={() => handleShowViewDokumen(row)}>
                                <FaEye />
                            </Button>
                        </div>
                        {localStorage.getItem('isEditStorage') === '1' ?
                            <>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='warning' onClick={() => handleShowEditDokumen(row)}>
                                        <FaEdit />
                                    </Button>
                                </div>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='danger' onClick={() => handleShowConfirmDelete(row)}>
                                        <FaTrash />
                                    </Button>
                                </div>
                            </> : ''
                        }
                    </div>
                </>
            )
        }
    ]

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <h5 className="mb-4">Dokumen</h5>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditStorage') === '1' ?
                            <div className="col-7">
                                <Button type="button" variant="primary" size="sm" onClick={handleShowAddDokumen}><FaPlus /> Tambah Dokumen</Button>
                            </div> : ''
                    }

                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listPpmDok}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalData}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    persistTableHead={true}
                />
            </div>
            {
                localStorage.getItem('isEditStorage') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveDokumen('kemasan')} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelDokumen('komoditi')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }

            <Modal
                show={showAddDokumen}
                onHide={handleCloseAddDokumen}
                backdrop="static"
                keyboard={false}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Tambah Dokumen</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kode Dokumen<span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="kd_dokumen" placeholder="Kode Dokumen" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionJenisDokumen}
                                value={valueJenisDokOpt}
                                getOptionLabel={(option) => option.id + ' - ' + option.jenisDok}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeJenisDokOpt}
                            />
                            {kelengkapan.jenisDok && <div className='text-danger'>{kelengkapan.jenisDok}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Seri Dokumen</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="seri_dok" placeholder="Seri Dokumen" value={valueSeriDok} onChange={onChangeSeriDok} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Dokumen<span className='text-danger'> *</span></label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control-sm" name="no_dokumen" placeholder="Nomor Dokumen" value={valueNoDok} onChange={onChangeNoDok} />
                            {kelengkapan.nomor && <div className='text-danger'>{kelengkapan.nomor}</div>}
                        </div>
                        <label className="col-sm-2 col-form-label-sm">Tanggal Dokumen<span className='text-danger'> *</span></label>
                        <div className="col-4">
                            <input type="date" className="form-control-sm" name="tgl_dokumen" placeholder="Tanggal Dokumen" value={valueTglDok} onChange={onChangeTglDok} />
                            {kelengkapan.tanggal && <div className='text-danger'>{kelengkapan.tanggal}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Negara<span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="negara" placeholder="Negara" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionNegDokOpt}
                                value={valueNegaraOpt}
                                getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                getOptionValue={(option) => option.kodeNegara}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeNegDokOpt}
                            />
                            {kelengkapan.negara && <div className='text-danger'>{kelengkapan.negara}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Upload Dokumen (max 2 Mb)<span className='text-danger'> *</span></label>
                        <div className="col">
                            <input type="file" className="form-control-sm" name="dok_path" placeholder="Upload File" accept='application/pdf' onChange={e => handleUploadFile(e)} />
                        </div>
                        {kelengkapan.file && <div className='text-danger'>{kelengkapan.file}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddDokumen} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" onClick={handleShowConfirmSave} size='sm'><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showEditDokumen}
                onHide={handleCloseEditDokumen}
                backdrop="static"
                keyboard={false}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Ubah Dokumen</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kode Dokumen<span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="kd_dokumen" placeholder="Kode Dokumen" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionJenisDokumen}
                                value={valueJenisDokOpt}
                                getOptionLabel={(option) => option.id + ' - ' + option.jenisDok}
                                getOptionValue={(option) => option.id}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeJenisDokOpt}
                            />
                            {kelengkapan.jenisDok && <div className='text-danger'>{kelengkapan.jenisDok}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Seri Dokumen</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="seri_dok" placeholder="Seri Dokumen" value={valueSeriDok} onChange={onChangeSeriDok} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Dokumen<span className='text-danger'> *</span></label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control-sm" name="no_dokumen" placeholder="Nomor Dokumen" value={valueNoDok} onChange={onChangeNoDok} />
                            {kelengkapan.nomor && <div className='text-danger'>{kelengkapan.nomor}</div>}
                        </div>
                        <label className="col-sm-2 col-form-label-sm">Tanggal Dokumen<span className='text-danger'> *</span></label>
                        <div className="col-4">
                            <input type="date" className="form-control-sm" name="tgl_dokumen" placeholder="Tanggal Dokumen" value={valueTglDok} onChange={onChangeTglDok} />
                            {kelengkapan.tanggal && <div className='text-danger'>{kelengkapan.tanggal}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Negara<span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="negara" placeholder="Negara" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionNegDokOpt}
                                value={valueNegaraOpt}
                                getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                getOptionValue={(option) => option.kodeNegara}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeNegDokOpt}
                            />
                            {kelengkapan.negara && <div className='text-danger'>{kelengkapan.negara}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Upload Dokumen (max 2 Mb)<span className='text-danger'> *</span></label>
                        <div className="col">
                            <input type="file" className="form-control-sm" name="dok_path" placeholder="Upload File" accept='application/pdf' onChange={e => handleUploadFile(e)} />
                        </div>
                        {kelengkapan.file && <div className='text-danger'>{kelengkapan.file}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditDokumen} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" size='sm' onClick={handleShowConfirmSave}><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showViewDokumen}
                onHide={handleCloseViewDokumen}
                backdrop="static"
                keyboard={false}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Lihat Dokumen</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kode Dokumen</label>
                        <div className='col-sm-4'>
                            {detilDokumen !== null ? <JenisDokumen id={detilDokumen.kodeDokumen} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Seri Dokumen</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="seri_dok" placeholder="Seri Dokumen" value={detilDokumen !== null ? detilDokumen.trPpkDokPK.seri : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Dokumen</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control-sm" name="no_dokumen" placeholder="Nomor Dokumen" value={detilDokumen !== null ? detilDokumen.nomor : ''} disabled />
                        </div>
                        <label className="col-sm-2 col-form-label-sm">Tanggal Dokumen</label>
                        <div className="col-4">
                            <input type="date" className="form-control-sm" name="tgl_dokumen" placeholder="Tanggal Dokumen" value={detilDokumen !== null ? detilDokumen.tanggal : null} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Negara</label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="negara" placeholder="Negara" /> */}
                            {detilDokumen !== null ? <Negara id={detilDokumen.negara} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Upload Dokumen (max 2 Mb)</label>
                        <div className="col">
                            {/* <input type="file" className="form-control-sm" name="dok_path" placeholder="Upload File" accept='application/pdf' onChange={e => handleUploadFile(e)} /> */}
                            {detilDokumen !== null ? <><Button size='sm' variant='info' onClick={() => handleClickPreview(detilDokumen.dokPath)}><FaEye /> Preview Dok</Button></> : ''}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseViewDokumen} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Dokumen?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Dokumen Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Dokumen Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmDelete &&
                <SweetAlert
                    title="Hapus Data Dokumen?"
                    warning
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickDelete}
                    onCancel={handleCloseConfirmDelete}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >Data Dokumen : {detilDokumen !== null ? detilDokumen.nomor : ''}</SweetAlert>
            }
            {
                showDeleteSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Dokumen Berhasil"
                    onConfirm={handleClickDeleteSuccess}
                    btnSize="sm"
                />
            }
            {
                showDeleteFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Dokumen Gagal"
                    onConfirm={handleClickDeleteFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ViewDokumen